export enum AiChatMessageRole {
  Participant = 'participant',
  Assistant = 'assistant'
}

export enum AiChatStatus {
  Active = 'active',
  Completed = 'completed',
  Failed = 'failed'
}

export interface IAiChatMessage {
  content: string;
  mediaId?: string;
  role: AiChatMessageRole;
}

export interface IAiChatState {
  messages: IAiChatMessage[];
  pendingQuestion?: string;
  status: AiChatStatus;
  version: number;
}

export type AiChatPageState = Record<string, IAiChatState>;
